import React from 'react'
import ViewNotes from './fileupload/viewNotes';

const StudyNotesView = () => {
    return (
        <>
            <ViewNotes type="Note" plural="resources" sponsorStudies={true} />
        </>
    )
}
export default StudyNotesView;